import { render, staticRenderFns } from "./DelPermission.vue?vue&type=template&id=24b0f7af"
import script from "./DelPermission.vue?vue&type=script&lang=js"
export * from "./DelPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports